import React, { useState, Suspense } from "react";
import { Outlet } from "react-router-dom";

import Header from "./Header";
import Sidebar from "./Sidebar";
import LoadingScreen from "../pages/loadingScreen/LoadingScreen";

const Layouts = () => {

  const [isClosed, setIsClosed] = useState(false);
  const [openMenus, setOpenMenus] = useState({});

  const toggleMenu = (index) => {
    setOpenMenus((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  return (
    <div className="layout-root">
      <div
        className={`layout-content-row ${isClosed ? "sidebar-collapsed" : ""}`}
      >
        <div className="sidebar-main-sec">
          <Sidebar
            isClosed={isClosed}
            openMenus={openMenus}
            toggleMenu={toggleMenu}
          />
          <div></div>
        </div>

        <div className="main-content">
          <Header
            toggleSidebar={() => setIsClosed(!isClosed)} prev
          />
          <div className="middle-content">
            <Suspense fallback={<div><LoadingScreen /></div>}>
              <Outlet />
            </Suspense>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Layouts;
